<template>
	<div class="container">
		<div class="logistics">
			<div class="items">
				<div class="item-span">手机号</div>
				<div class="item-input">
					{{info.phone}}
				</div>
			</div>
		</div>
		<div class="xian"></div>
		<div class="Payment" @click="goDetail()">
			<div class="payspan">
				<span class="refund">个人信息</span>
			</div>
			<div class="payimg">
				<img src="../../../assets/icon/icon_more.png" alt="" width="100%" />
			</div>
		</div>
		<div class="xian"></div>
		<div class="Payment paymt">
			<div class="payspan" @click="outLogin">
				<span class="refund">解绑/退出</span>
			</div>
			<div class="payimg">
				<img src="../../../assets/icon/icon_more.png" alt="" width="100%" />
			</div>
		</div>
		<div class="btn" @click="outLogin">退出登录</div>
	</div>
</template>

<script>
	import { queryMemberInfo } from "@/api/api";
	import wx from 'weixin-js-sdk'
	export default {
		data() {
			return {
				info:[]
			};
		},
		methods: {
			goDetail() {
				this.$router.push({
					path: "/orders/personalinformation?username="+this.info.name+'&&sex='+this.info.sex+'&&useremail='+this.info.email,
				});
			},
			async queryUserinfo(){
				let params = {}
				const res = await queryMemberInfo(params);
				if (res.code === "0000") {
					this.info = res.data;
				} else {
					this.$toast(res.msg);
				}
			},
			outLogin(){
				localStorage.clear();
				wx.miniProgram.switchTab({
					url: '/pages/my/my'
				})
			}
		},
		created() {
			if(this.$route.query.token){
				this.$cookies.set('token',this.$route.query.token);
			}
			this.queryUserinfo();
		},
	};
</script>

<style scoped lang="scss">
	.container {
		.logistics {
			padding: 0 30px;
			background-color: #fff;
			margin-top: 20px;

			.items {
				display: flex;
				justify-content: space-between;
				padding-top: 36px;
				padding-bottom: 34px;
				font-size: 28px;
				color: #999999;
				.item-span,
				.item-input {
					text-align: right;
				}

				.item-span {
					font-size: 30px;
					font-weight: 500;
					color: #333333;
					line-height: 40px;
				}

				.input {
					-webkit-box-pack: end;
					-webkit-justify-content: flex-end;
					justify-content: flex-end;
					text-align: right;
					font-size: 28px;
					font-weight: 500;
					color: #999999;
					line-height: 40px;
					border: 0;
				}
			}
		}

		.xian {
			width: 710px;
			height: 1px;
			border: 1px solid #efefef;
		}

		.Payment {
			padding-top: 35px;
			padding-bottom: 37px;
			padding-left: 30px;
			padding-right: 30px;
			background-color: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.payspan {
				span {
					display: block;
				}

				.refund {
					font-size: 30px;
					font-family: Helvetica;
					color: #333333;
					line-height: 34px;
					padding-bottom: 5px;
				}

				.payagree {
					font-size: 28px;
					font-family: PingFangSC, PingFangSC-Medium;
					font-weight: 500;
					color: #999999;
					line-height: 40px;
				}
			}

			.payimg {
				width: 32px;
				height: 32px;
			}
		}

		.paymt {
			padding-top: 35px;
			padding-bottom: 31px;
		}

		.btn {
			font-size: 36px;
			font-family: PingFangSC, PingFangSC-Medium;
			font-weight: 500;
			color: #ffffff;
			text-align: center;
			width: 580px;
			height: 88px;
			line-height: 88px;
			margin: 300px auto;
			background: #1e53a4;
			border-radius: 44px;
		}
	}
</style>
